export enum HomeStatus {

    /**
     * Usuário Identificado que não comecou a preencher o cadastro
     */
    UserNotFilling = 1,

    /**
     * Usuário Identificado em qualquer passo do cadastro
     */
    UserIdentified,

    /**
     * Cadastro que ainda não enviou documentos
     */
    RegisteredWithoutDocs,

    /**
     * Cadastrado recusado pela rocket - envie documetos
     */
    RegisteredSendDocs,

    /**
     * Cadastrado que enviou documentos - Análise manual
     */
    RegisteredDocsSended,

    /**
     * Cadastrado que enviou documentos - Análise manual e não possui suitability
     */
    RegisteredDocsSendedWithoutSuitability,

    /**
     * Cadastrado com pendências externas
     */
    RegisteredExternalIssuer,

    /**
     * Cadastrado com conta aberta e sem dinheiro
     */
    RegisteredWithoutMoney,

    /**
     * Conta Ativa
     */
    Activated,

    /**
     * Conta Ativa com dinheiro negativo
     */
    ActivatedNegative
}
